/**
 * Execute callback when DOM is ready
 * Handles cases where script loads after DOM is already loaded
 */
export default (callback: () => void): void => {
  if (
    window.document.readyState === 'complete'
    || window.document.readyState === 'interactive'
  ) {
    callback();
  } else {
    window.document.addEventListener('DOMContentLoaded', callback);
  }
};
